import React, { useState } from "react";
import facebook from "../../../assets/images/fb-footer.svg";
import lkdinInstagram from "../../../assets/images/lkdin-footer.svg";
import footerLogo from "../../../assets/images/logo-footer.svg";
import twitter from "../../../assets/images/tw-footer.svg";
import "../../../css/main.css";
import useMediaQuery from "../../../hooks/useMediaQuery";
import QueriesReachOut from "../../advance/QueriesReachOut";

function Footer(props) {
  const [expandFirst, setExpandFirst] = useState(false);
  const [expandSecond, setExpandSecond] = useState(false);
  const [expandThird, setExpandThird] = useState(false);
  const [expandFourth, setExpandFourth] = useState(false);
  const isMobile = useMediaQuery("screen and (max-width: 991px)");
  return (
    <div
      style={{
        display: "flex",
        // bottom: "0px",
        // position: "fixed",
        flexDirection: "row",
        width: "100%",
        // zIndex: "1",
        flexShrink: "0",
        marginTop: "auto",
        padding: "0px",
      }}
    >
      <footer style={{ width: "100%" }} class="footer">
        <QueriesReachOut {...props} />
        <div class="top-footer">
          <div class="container">
            <div class="row">
              <div style={{ marginTop: "10px" }}>
                <ul class="list-unstyled">
                  <li>
                    <h6>Connect with us at</h6>
                  </li>
                </ul>
              </div>
              {isMobile ? (
                <div style={{}}>
                  <ul class="list-unstyled">
                    <li class="pb-0">
                      {/* <a
                        href="https://www.abfldirect.com/"
                        target="_blank"
                        style={{
                          backgroundColor: "none",
                          color: "#0074CC",
                          textDecoration: "none",
                          fontSize: "20px",
                        }}
                      >
                        www.abfldirect.com
                      </a> */}
                      <ul class="list-unstyled d-flex social-icons">
                        <li>
                          <a
                            href="https://x.com/abcapital?s=21"
                            target="_blank"
                          >
                            <img src={twitter} alt="twitter footer" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/company/aditya-birla-capital/"
                            target="_blank"
                          >
                            <img src={lkdinInstagram} alt="instagram" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.facebook.com/share/1B9KwwsTPs/?mibextid=wwXIfr"
                            target="_blank"
                          >
                            <img src={facebook} alt="facebook" />
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              ) : (
                <></>
              )}
              {/* <div class="col-lg-8 col-md-7 col-sm-12 order-md-2 order-last">
                <ul
                  class="list-unstyled d-sm-flex footer-menu"
                  style={{ display: isMobile ? "" : "flex" }}
                >
                  <li>
                    <ul class="list-unstyled">
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          // console.log("clicked");
                          setExpandFirst(!expandFirst);
                        }}
                      >
                        <h6>About Us</h6>
                      </li>
                      {expandFirst ? (
                        <>
                          <li>
                            <a href="javascript:void(0);">Company Profile</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">Sitemap</a>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </li>
                  <li>
                    <ul class="list-unstyled">
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setExpandSecond(!expandSecond);
                        }}
                      >
                        <h6>Our Solutions</h6>
                      </li>
                      {expandSecond ? (
                        <>
                          <li>
                            <a href="javascript:void(0);">Home Finance</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">Personal Finance</a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">
                              SME <label class="font-menu-arial">&</label>{" "}
                              Business finance
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">
                              Loan against securities
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">Mortgage Finance</a>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </li>
                  <li>
                    <ul class="list-unstyled">
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setExpandThird(!expandThird);
                        }}
                      >
                        <h6>Tools and Knowledge</h6>
                      </li>
                      {expandThird ? (
                        <>
                          <li>
                            <a href="javascript:void(0);">
                              Home Loan EMI Calculator
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">
                              Home Loan Eligibility Calculator
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">
                              Risk Factors and FAQs
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);">
                              Financial Results & Reports
                            </a>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </li>
                  <li>
                    <ul class="list-unstyled">
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setExpandFourth(!expandFourth);
                        }}
                      >
                        <h6>Forms & Downloads</h6>
                      </li>
                      {expandFourth ? (
                        <>
                          <li>
                            <a href="javascript:void(0);">Forms</a>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </li>
                </ul>
              </div> */}
              {isMobile ? (
                <></>
              ) : (
                <div class="col-lg-2 col-7 col-md-3 order-md-last justify-content-md-end d-flex align-items-start align-items-md-start">
                  <ul class="list-unstyled">
                    <li>
                      <h6>Connect with us at</h6>
                    </li>
                    <li class="pb-0">
                      {/* <a
                        href="https://www.abfldirect.com/"
                        target="_blank"
                        style={{
                          backgroundColor: "none",
                          color: "#0074CC",
                          textDecoration: "none",
                          fontSize: "20px",
                        }}
                      >
                        www.abfldirect.com
                      </a> */}
                      <ul class="list-unstyled d-flex social-icons">
                        <li>
                          <a
                            href="https://x.com/abcapital?s=21"
                            target="_blank"
                          >
                            <img src={twitter} alt="twitter footer" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/company/aditya-birla-capital/"
                            target="_blank"
                          >
                            <img src={lkdinInstagram} alt="instagram" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.facebook.com/share/1B9KwwsTPs/?mibextid=wwXIfr"
                            target="_blank"
                          >
                            <img src={facebook} alt="facebook" />
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
